module.exports = __webpack_public_path__ + "img/price-settings-desktop-en.4e3f6f31.jpg";